import { CalendarToolbar } from '@/features/calendar/CalendarToolbar';
import { CalendarGrid } from '@/features/calendar/CalendarGrid';
import { PlanListView } from '@/features/calendar/PlanListView';
import { useAppStore } from '@/app/store';

export function CalendarPage() {
  const viewMode = useAppStore((s) => s.viewMode);
  return (
    <>
      <CalendarToolbar />
      {viewMode === 'month' ? <CalendarGrid /> : <PlanListView />}
    </>
  );
}
